<!-- /*!
* Copyright © 2025 FBSPL. All rights reserved.
* This script is proprietary and confidential.
* Unauthorized copying, distribution, or modification is strictly prohibited.
*/ -->
<div class="video-container" [class.no-click]="!videoUrl">
  @if (showOverlay) {
  <div class="overlay" (click)="playVideo()">
    <img class="thumbnails" [src]="cdnThumbnail" [alt]="alt" loading="lazy" />
    @if (videoUrl) {
    <div
      class="play-button"
      [ngClass]="{
        'white-button': useWhitePlayButton,
        'blue-button': !useWhitePlayButton
      }"
    >
      <img
        [src]="
          useWhitePlayButton
            ? 'https://d1585q1wairh36.cloudfront.net/assets/Icon/white-playicon.svg'
            : 'https://d1585q1wairh36.cloudfront.net/assets/Icon/blue-playicon.svg'
        "
        alt="Play Video"
      />
    </div>
    }
  </div>
  } @if (!showOverlay && safeVideoUrl) {
  <iframe
    #videoPlayer
    class="video-iframe | safe"
    allowfullscreen
    allow="autoplay; clipboard-write"
    loading="lazy"ks
    title="Vimeo Video Player"
    [src]="safeVideoUrl"
    frameborder="0"
  ></iframe>
  }
</div>
